"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const jlDataUtils_1 = require("../../utils/jlDataUtils");
const dispatchAnalytics_1 = require("../../utils/dispatchAnalytics");
const isValidKevelEvent = (event) => {
    return Boolean(event.adId && event.type && event.clickUrl && event.impressionUrl);
};
const KevelAnalytics = ({ events = [], browserCacheEnabled = false, }) => {
    (0, react_1.useEffect)(() => {
        var _a;
        const validEvents = events.filter(isValidKevelEvent);
        if (validEvents.length === 0) {
            return;
        }
        if (browserCacheEnabled) {
            const renderTimestamp = (_a = document
                .querySelector('meta[name="esi-render-time"]')) === null || _a === void 0 ? void 0 : _a.getAttribute("content");
            const isCached = renderTimestamp
                ? Date.now() - parseInt(renderTimestamp) > 5000
                : false;
            if (isCached) {
                return;
            }
        }
        (0, jlDataUtils_1.addKevelBannersToJlData)(validEvents);
        const dispatchImpressions = () => {
            validEvents.forEach((eventData) => {
                (0, dispatchAnalytics_1.dispatchKevelAnalyticsEvent)(Object.assign({ action: "kevel.impression" }, eventData));
            });
        };
        let eventListener = null;
        if (window && window.Bootstrapper && window.Bootstrapper.ensEventsReady) {
            dispatchImpressions();
        }
        else {
            eventListener = dispatchImpressions;
            document.body.addEventListener("ensEventsReady", eventListener, {
                once: true,
            });
        }
        return () => {
            // Only remove THIS component's adIds, not all banners (ESI isolation)
            const adIds = validEvents.map((event) => event.adId);
            (0, jlDataUtils_1.removeKevelBannersFromJlDataByAdIds)(adIds);
            if (eventListener) {
                document.body.removeEventListener("ensEventsReady", eventListener);
            }
        };
    }, [events, browserCacheEnabled]);
    return null;
};
exports.default = KevelAnalytics;
